import { loading, succeeded, failed } from "./constants";

export const setWithExpiry = (key, value, ttl) => {
  const now = new Date().getTime();
  const item = {
    value,
    expiry: now + ttl,
  };
  localStorage.setItem(key, JSON.stringify(item));
};

export const getWithExpiry = (key) => {
  const itemStr = localStorage.getItem(key);
  if (!itemStr) {
    return null;
  }

  const item = JSON.parse(itemStr);
  const now = new Date().getTime();

  if (now > item.expiry) {
    localStorage.removeItem(key);
    return null;
  }

  return item.value;
};

export const jsonToFormDataDeep = (
  jsonObject,
  formData = new FormData(),
  parentKey = "",
) => {
  Object.entries(jsonObject).forEach(([key, value]) => {
    const newKey = parentKey ? `${parentKey}[${key}]` : key;

    if (Array.isArray(value)) {
      value.forEach((item, index) => {
        if (Array.isArray(item)) {
          jsonToFormDataDeep(item, formData, `${newKey}[${index}]`);
        } else if (typeof item === "object" && item !== null) {
          jsonToFormDataDeep(item, formData, `${newKey}[${index}]`);
        } else {
          formData.append(`${newKey}[${index}]`, item);
        }
      });
    } else if (typeof value === "object" && value !== null) {
      jsonToFormDataDeep(value, formData, newKey);
    } else {
      formData.append(newKey, value);
    }
  });

  return formData;
};

export const jsonToFormData = (jsonObject) => {
  const formData = new FormData();

  Object.entries(jsonObject).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      value.forEach((item, index) => {
        formData.append(`${key}[${index}]`, item);
      });
    } else {
      formData.append(key, value);
    }
  });

  return formData;
};

export const setLoadingState = (state, key) => {
  state[`${key}Status`] = loading;
  state[`${key}Error`] = null;
};

export const setFulfilledState = (state, key, payload, key2) => {
  state[`${key}Status`] = succeeded;
  state[`${key}Error`] = null;
  state[key] = { ...state[key], ...payload };

  if (key2) {
    state[key2] = { ...state[key2], ...payload };
  }
};

export const setRejectedState = (state, key, error) => {
  state[`${key}Status`] = failed;
  state[`${key}Error`] = error?.message || "API Error";
  state.toast = error;
};
